<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    class="evv-dialog"
    :title="$t('evvDialog.textTitle')"
    blocking
    @hide="onDialogHide"
    @submit="onSubmitForm"
  >
    <p class="q-mt-none">
      {{ $t('evvDialog.textCaption') }}
    </p>
    <hr-text-field
      v-model="evvNote"
      lazy-rules
      :rules="evvNoteRules"
      :label="$t('evvDialog.evvNoteLabel')"
      autofocus
      outlined
      counter
      maxlength="256"
      class="col-12"
    />
    <template #actions>
      <hr-destructive-btn
        :label="$t('common.buttonRetry')"
        @click="onRetry"
      />
      <hr-confirm-btn
        type="submit"
        :label="$t('common.buttonSubmit')"
        :loading="savingSpinner"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import { size } from 'lodash';
import {
  HrFormDialog,
  HrConfirmBtn,
  HrDestructiveBtn,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'EVVDialog',

  components: {
    HrFormDialog,
    HrConfirmBtn,
    HrDestructiveBtn,
    HrTextField,
  },

  emits: ['ok', 'hide'],

  data() {
    return {
      savingSpinner: false,
      evvNote: '',

      evvNoteRules: [
        (val) => !!val || this.$t('evvDialog.evvNoteRequired'),
        (val) => (size(val) <= 256) || this.$t('evvDialog.evvNoteTooLong'),
      ],
    };
  },

  methods: {

    async onSubmitForm() {
      this.$emit('ok', {
        evvInfo: {
          evvReasonCode: 15, // Currently hard-coded - might be user-selected in the future
          evvNote: this.evvNote,
        },
        retry: false,
      });
      this.hide();
    }, // onSubmitForm()

    onRetry() {
      this.$emit('ok', {
        retry: true,
      });
      this.hide();
    }, // onRetry()

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      this.$emit('hide');
    },

  },
};
</script>
<style scoped>
.evv-dialog {
  z-index: 10000 !important;
}
</style>
